import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    public router: Router
  ) { }

  getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }

  public loginUser() {
    this.router.navigate(["/enetassess"]);
  }

  public goToEnetassess() {
    this.router.navigate(["/enetassess"]);
  }

  public goToFeedback(){
    this.router.navigate(["/feedback"]);
  }

  public logoutUser() {
    window.location.href = "login";
  }

  public logoutUserDelayed() {
    setTimeout( () => { 
      window.location.href = "login"; 
    }, 10000 );
    
  }

  public logoutMockUser(mockId) {
    window.location.href = "login?mock=1&mid=" + mockId;
  }

  public launchExam() {
    this.router.navigate(["/loadexam"]);
  }

  public launchExamQuestions() {
    this.router.navigate(["/questions"]);
  }
}
